import React from 'react';

const Home = () => {
    return <div>HI</div>;
}

export default Home;